module.exports = __webpack_public_path__ + "static/Mockup-5eca330bcd9aebc18ad5f14f964ba2c1.webp";